import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { normalizeAssetUrl } from '../../utils/vehicleImage';

const PhotoGallery = ({ photos = [], buttonText = '📷 View Photos', buttonStyle = {}, altTextPrefix = 'Order' }) => {
    const [photoGalleryModal, setPhotoGalleryModal] = useState(false);
    const [photoViewModal, setPhotoViewModal] = useState(false);
    const [selectedPhoto, setSelectedPhoto] = useState(null);

    if (!photos || !Array.isArray(photos) || photos.length === 0) {
        return null;
    }

    const normalizedPhotos = photos
        .map(photo => {
            const normalizedUrl = normalizeAssetUrl(photo && photo.url ? photo.url : '');

            if (!normalizedUrl) {
                return null;
            }

            return {
                ...photo,
                url: normalizedUrl,
            };
        })
        .filter(Boolean);

    if (normalizedPhotos.length === 0) {
        return null;
    }

    const defaultButtonStyle = {
        background: 'none',
        border: 'none',
        padding: 0,
        textDecoration: 'underline',
        color: 'white',
        cursor: 'pointer',
        fontSize: 'inherit',
        fontFamily: 'inherit',
        textAlign: 'left',
        ...buttonStyle
    };

    return (
        <>
            <Button
                href="#"
                style={defaultButtonStyle}
                onClick={e => {
                    e.preventDefault();
                    setPhotoGalleryModal(true);
                }}
            >
                {buttonText} ({normalizedPhotos.length})
            </Button>

            {/* Photo Gallery Modal - Shows thumbnails */}
            <Modal isOpen={photoGalleryModal} toggle={() => setPhotoGalleryModal(false)} size="lg">
                <ModalBody>
                    <h5 style={{ color: 'black', marginBottom: '20px' }}>Photos ({normalizedPhotos.length})</h5>
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
                            gap: '15px',
                            padding: '10px'
                        }}
                    >
                        {normalizedPhotos.map((photo, index) => (
                            <div key={photo.fileId || index} style={{ textAlign: 'center' }}>
                                <img
                                    src={photo.url}
                                    alt={`${altTextPrefix} ${parseInt((photo.metadata && photo.metadata.photoIndex) || index) + 1}`}
                                    style={{
                                        width: '100%',
                                        height: '120px',
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        border: '2px solid transparent',
                                        transition: 'border-color 0.3s ease'
                                    }}
                                    onClick={() => {
                                        setSelectedPhoto(photo);
                                        setPhotoViewModal(true);
                                    }}
                                    onMouseOver={e => (e.target.style.borderColor = '#f7941d')}
                                    onMouseOut={e => (e.target.style.borderColor = 'transparent')}
                                />
                                <p style={{ color: '#2b3553', fontSize: '12px', marginTop: '5px' }}>Photo {parseInt((photo.metadata && photo.metadata.photoIndex) || index) + 1}</p>
                                {photo.metadata && photo.metadata.capturedAtLabel ? (
                                    <p style={{ color: '#4b5563', fontSize: '11px', marginTop: '4px', marginBottom: '0' }}>
                                        {photo.metadata.capturedAtLabel}
                                    </p>
                                ) : null}
                                {photo.metadata && photo.metadata.locationLabel ? (
                                    <p style={{ color: '#4b5563', fontSize: '11px', marginTop: '2px', marginBottom: '0' }}>
                                        {photo.metadata.locationLabel}
                                    </p>
                                ) : null}
                            </div>
                        ))}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={() => setPhotoGalleryModal(false)}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>

            {/* Photo View Modal - Shows full-size photo */}
            <Modal isOpen={photoViewModal} toggle={() => setPhotoViewModal(false)} size="lg" style={{ maxWidth: '90vw' }}>
                <ModalBody style={{ padding: '15px', textAlign: 'center' }}>
                    {selectedPhoto && (
                        <>
                            <img
                                src={selectedPhoto.url}
                                alt={`${altTextPrefix} full size view`}
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '80vh',
                                    objectFit: 'contain',
                                    borderRadius: '8px'
                                }}
                            />
                            {selectedPhoto.metadata && (selectedPhoto.metadata.capturedAtLabel || selectedPhoto.metadata.locationLabel) ? (
                                <div style={{ marginTop: '12px', color: '#2b3553', fontSize: '13px' }}>
                                    {selectedPhoto.metadata.capturedAtLabel ? <p style={{ marginBottom: '4px' }}><strong>Taken:</strong> {selectedPhoto.metadata.capturedAtLabel}</p> : null}
                                    {selectedPhoto.metadata.locationLabel ? <p style={{ marginBottom: 0 }}><strong>GPS:</strong> {selectedPhoto.metadata.locationLabel}</p> : null}
                                </div>
                            ) : null}
                        </>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setPhotoViewModal(false)}>
                        Back to Gallery
                    </Button>
                    <Button
                        color="danger"
                        onClick={() => {
                            setPhotoViewModal(false);
                            setPhotoGalleryModal(false);
                        }}
                    >
                        Close All
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default PhotoGallery;
